import { useMutation, useQueryClient } from '@tanstack/react-query';

import { exercisesService } from '../services';
import type { AssignExerciseInput } from '../types';

import { clientExercisesKeys } from './useExercises';

export function useAssignExercise(clientId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: AssignExerciseInput) => exercisesService.assignToClient(clientId, input),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: clientExercisesKeys.operation('by-client', { clientId }),
      });
    },
  });
}
